import React, { useState } from "react";
import "../styles/NewsPage.css";

// ══════════════════════════════════════════════════════
// HOW TO ADD MORE NEWS:
// 1. Add a new object to the NEWS array below
// 2. For news WITH image: add  image: require("../assets/photos/news-img.jpg")
// 3. For news WITHOUT image: leave out the image field
// 4. Categories: "New Scheme" | "Bank News" | "Event" | "Notice"
// ══════════════════════════════════════════════════════

const NEWS = [
{
      id: 1,
      category: "Bank News",
      date: "25th August 2026",
      isNew: true,
      title: "58th Annual General Meeting — 25th August 2026",
      preview: "The 58th AGM will be held on 25th Aug 2026 at 11:00 AM at Shri Mumbai Halwai Bhatia Mahajanwadi Hall, Kalbadevi Road, Mumbai..",
      details: [
             "The 58th Annual General Meeting of The Sahyadri Sahakari Bank Ltd will be held on:",
             "📅 Date: 25th August 2026",
             "🕐 Time: 11:00 AM",
             "📍 Venue: Shri Mumbai Halwai Bhatia Mahajanwadi Hall, 398 CD, Kalbadevi Road, Mumbai – 400002",
             "All members are cordially invited to attend the meeting. For more information please contact your nearest branch.",
      ],
          image: require("../assets/photos/AGM_2026.jpg"),
 },
{
      id: 2,
      category: "New Scheme",
      date: "1 August 2026",
      isNew: true,
      title: "Sahyadri Navudyojak",
      preview: "MSME advances scheme for Working Capital (CC Limit) and Purchase of Machinery, for existing and new customers.",
      details: [
       "MSME advances scheme for Working Capital (CC Limit) and Purchase of Machinery, for existing and new customers. Approved vide Board meeting dated 28th July 2026.",
      ],
          image: require("../assets/photos/navudyojak-banner.png"),
  },
 {
      id: 3,
      category: "New Scheme",
      date: "1 August 2026",
      isNew: true,
      title: "Sukhakarta Thev Yojana",
      preview: "Special festive fixed deposit scheme with attractive monthly interest payout.",
      details: [
       "Special festive fixed deposit scheme introduced to strengthen the Bank's deposit base, launched to coincide with the Ganesh Chaturthi festive season.",
      ],
          image: require("../assets/photos/sukhakarta-banner.jpg"),
  },
{
    id: 4,
    category: "Bank News",
    date: "27 June 2026",
    isNew: true,
    title: "New Job Openings",
    preview: "New Job Openings For 2 Diffrent Position's",
    details: [
      "The Sahyadri Sahakari Bank Ltd Mumbai New Job Openings",
      "📅 Application Submission Start Date: 28 June 2026",
      "📅 Application Submission End Date: 10 July 2026",
      "📍 Note: Application are received through website please visit job posting option under career's page",
      "No Applications will be answered after end date.",
    ],
    // Add image when ready:
    image: require("../assets/photos/new-job-posting-news.png"),
  },
{
    id: 5,
    category: "Bank News",
    date: "18 May 2026",
    isNew: false,
    title: "Vithalwadi Branch Shifting",
    preview: "Vihalwadi Branch Shifted to New Location",
    details: [
      "The Sahyadri Sahakari Bank Ltd Mumbai Vithalwadi Branch Shifting Event will be held on: ",
      "📅 Date: 20 May 2026",
      "🕐 Time: 11:00 AM",
      "📍 Venue: Ground Floor Anand Properties , 384-M , Kalbadevi Road Dabholkarwadi , Bhuleshwar Mumbai-400002",
      "All members and customers are cordially invited to attend the Event.",
    ],
    // Add image when ready:
    image: require("../assets/photos/vithalwadi-branch-shifting.jpg"),
  },
  {
      id:6,
      category: "New Scheme",
      date: "1 May 2026",
      isNew: true,
      title: "Sahyadri Vyapari Scheme",
      preview: "Cash credit limit facility for small traders, shopkeepers and retailers @ 9.50 % interest rates...",
      details: [
       "In order to accelerate growth in the credit portfolio, improve fund flow through operations in cash Credit accounts,  strengthen the CD ratio and to provide working capital finance to small traders and shopkeeper for meeting day to day business requirments, we are launching Sahyadri Vyapari Scheme -Cash Credit Limit, approved vide BOD meeting Dated 22nd April 2026.  ",
      ],
          image: require("../assets/photos/vyapari-news.png"),
  },
  {
    id: 7,
    category: "Closed",
    date: "1 January 2026",
    isNew: false,
    title: "Introducing Shatak Deposit Scheme — 100 Days @ 6.25%",
    preview: "Invest for 100 days and earn guaranteed returns at 6.25% p.a. Safe, simple and rewarding for all customers...",
    details: [
      "The Sahyadri Sahakari Bank Ltd is pleased to introduce the Shatak Deposit Scheme — a special 100-day fixed deposit at an attractive interest rate of 6.25% per annum.",
      "This scheme is open to all existing and new account holders. Minimum deposit amount is ₹1,000 with no upper limit. The scheme offers guaranteed returns and is fully safe and RBI regulated.",
      "Visit your nearest Sahyadri Sahakari Bank branch today to open your Shatak Deposit and start earning.",
    ],
    // No image for this news
  },
  {
    id: 8,
    category: "Bank News",
    date: "19 August 2025",
    isNew: false,
    title: "57th Annual General Meeting — 21st August 2025",
    preview: "The 57th AGM will be held on 21st Aug 2025 at 11:30 AM at Shri Mumbai Halwai Bhatia Mahajanwadi Hall, Kalbadevi Road, Mumbai...",
    details: [
      "The 57th Annual General Meeting of The Sahyadri Sahakari Bank Ltd will be held on:",
      "📅 Date: 21st August 2025",
      "🕐 Time: 11:30 AM",
      "📍 Venue: Shri Mumbai Halwai Bhatia Mahajanwadi Hall, 398 CD, Kalbadevi Road, Mumbai – 400002",
      "All members are cordially invited to attend the meeting. For more information please contact your nearest branch.",
    ],
    // Add image when ready:
    image: require("../assets/photos/agm-2025.png"),
  },
];

const CATEGORY_STYLES = {
  "New Scheme": "newspage-badge--orange",
  "Bank News":  "newspage-badge--blue",
  "Event":      "newspage-badge--green",
  "Notice":     "newspage-badge--blue",
};

const BORDER_STYLES = {
  "New Scheme": "newspage-item--orange",
  "Bank News":  "newspage-item--blue",
  "Event":      "newspage-item--green",
  "Notice":     "newspage-item--blue",
};

export default function NewsPage() {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <div className="newspage">

      {/* ── HERO ── */}
      <section className="newspage-hero">
        <h1 className="newspage-hero-title">News & Announcements</h1>
        <p className="newspage-hero-sub">
          Latest updates, schemes and news from The Sahyadri Sahakari Bank Ltd
        </p>
      </section>

      {/* ── NEWS LIST ── */}
      <div className="newspage-body">
        <div className="newspage-section-label">Latest News</div>

        {NEWS.map((item) => (
          <div
            key={item.id}
            className={`newspage-item ${BORDER_STYLES[item.category] || "newspage-item--blue"}`}
          >
            {/* ── HEADER (always visible) ── */}
            <div
              className="newspage-item-head"
              onClick={() => toggle(item.id)}
            >
              <div className="newspage-item-headleft">
                <div className="newspage-item-meta">
                  <span className={`newspage-badge ${CATEGORY_STYLES[item.category] || "newspage-badge--blue"}`}>
                    {item.category}
                  </span>
                  {item.isNew && (
                    <span className="newspage-badge newspage-badge--new">New</span>
                  )}
                  <span className="newspage-item-date">{item.date}</span>
                </div>
                <div className="newspage-item-title">{item.title}</div>
                <div className="newspage-item-preview">{item.preview}</div>
              </div>
              <div className={`newspage-item-arrow${openId === item.id ? " open" : ""}`}>
                &#8964;
              </div>
            </div>

            {/* ── EXPANDED BODY ── */}
            {openId === item.id && (
              <div className="newspage-item-body">

                {/* Image — only if provided */}
                {item.image && (
                  <div className="newspage-item-imgwrap">
                    <img src={item.image} alt={item.title} />
                  </div>
                )}

                {/* Details text */}
                <div className="newspage-item-text">
                  {item.details.map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>

              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
}